/**
 * sessionStorage keys under this prefix last one sign-in: signing out clears them. A window closed
 * "for this session" (such as the print page announcement) then opens again at the next sign-in
 * in the same tab, and a tab's business (tabBusiness) starts from the next user's own.
 */
export const LOGIN_SESSION_STORAGE_PREFIX = 'mp:login-session:'
